import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect:'/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import( '../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/case/orderManage',
    name: 'OrderManage',
    component: () => import( '../views/case/OrderManage.vue')
  },
  {
    path: '/case/opticalModule',
    name: 'OpticalModule',
    component: () => import( '../views/case/OpticalModule.vue')
  },
  {
    path: '/case/equipmentRepair',
    name: 'EquipmentRepair',
    component: () => import( '../views/case/EquipmentRepair.vue')
  },
  {
    path: '/case/electromagneticVehicle',
    name: 'ElectromagneticVehicle',
    component: () => import( '../views/case/ElectromagneticVehicle.vue')
  },
  {
    path: '/case/muBang',
    name: 'MuBang',
    component: () => import( '../views/case/MuBang.vue')
  },
  {
    path: '/case/platForm',
    name: 'PlatForm',
    component: () => import( '../views/case/PlatForm.vue')
  },
  {
    path: '/case/ehs',
    name: 'Ehs',
    component: () => import( '../views/case/Ehs.vue')
  },
  {
    path: '/case/secure',
    name: 'Secure',
    component: () => import( '../views/case/Secure.vue')
  },
  {
    path: '/case/hlx',
    name: 'Hlx',
    component: () => import( '../views/case/Hlx.vue')
  },
  {
    path: '/case/spectroGraph',
    name: 'Hlx',
    component: () => import( '../views/case/SpectroGraph.vue')
  },
  {
    path: '/fidc',
    name: 'Fidc',
    component: () => import( '../views/Fidc.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return {x:0,y:0}
  }
})

//解决点击重复的path报错问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router
